import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import { Box, Button, Center, Flex, Grid, Image, Skeleton, Text, VStack } from '@chakra-ui/react';
import Pagamento from '../../../images/Pagamento/ErroPagamento.svg';

function ErroPagamento() {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      navigate('/dashboard');
    }, 3000);
  }, []);

  return (
    <>
      <ChildHeader />
      <Box display="flex" justifyContent="center" alignItems="center" w="100%" minHeight="50vh" flexDirection="column">
        <VStack w={'100%'} justifyContent="center" alignItems="center">
          <Box bg={'#F3F3F3'} w={'80%'} align={'center'} p={4} borderRadius={'0.8em'}>
            <Image src={Pagamento} alt="Pagamento" />
            <Text color={'#585858'} fontWeight={'bold'} fontSize={'20px'} mt={2}>
              Ops... Aconteceu algum problema com seu pagamento. Consulte o banco do seu cartão.
            </Text>
          </Box>
        </VStack>
      </Box>
    </>
  );
}

export default ErroPagamento;
